/**
 * Created by razial on 15.05.2026.
 */

AdventureExpedition.register_nightparty_quests = function () {
    const locationId = "nightparty";
    const dynamic = {};

    [
        { code: "sidequest1", trigger: { unit: { code: "sidequest1", stage: 0 } }, perCollect: 3 },
        { code: "sidequest2", trigger: { unit: { code: "sidequest2", stage: 0 } }, perCollect: 1 },
        { code: "sidequest5", trigger: { unit: { code: "sidequest5", stage: 0 } }, perCollect: 1 },
        { code: "sidequest6", trigger: { unit: { code: "sidequest6", stage: 0 } }, perCollect: 3 }
    ].forEach((entry) => {
        const questDynamic = { rowCtor: ProgressQuestRow };
        if (entry.perCollect > 1) {
            questDynamic.addProgress = function (quest) {
                quest.progress += entry.perCollect;
            };
        }

        dynamic[entry.code] = {
            priority: 1,
            trigger: entry.trigger,
            dynamic: questDynamic,
            quest: { type: Map2d.MINE, unit: { code: entry.code, stage: 0  }, toMainWorld: true }
        };
    });

    [
        { questId: "advenergy", code: "advenergy" },
        { questId: "advreward", code: "advreward" }
    ].forEach((entry) => {
        dynamic[entry.questId] = {
            priority: 1,
            trigger: { unit: { code: "adv3rpcustomerbridge0", stage: 0 } },
            dynamic: {
                rowCtor: ProgressQuestRow,
                getTitle: function () {
                    return Messages.get(`Quest.${entry.questId}.title`);
                },
                getIcon: function () {
                    const icon = Quest.GetUnitIconResource(entry.questId);
                    if (icon) {
                        return new cc.Sprite(icon);
                    }
                    return UnitView.getUnitImage({ code: entry.code, stage: 0 }, { alignAnchorX: true });
                }
            },
            quest: { type: Map2d.PRIZE_HARVESTED, unit: { code: entry.code }, toMainWorld: true }
        };
    });

    [
        { code: "exprunes1", trigger: { unit: { code: "exprunes1", stage: 0 } } },
        { code: "exprunes2", trigger: { unit: { code: "exprunes2", stage: 0 } } },
        { code: "exprunes3", trigger: { unit: { code: "exprunes3", stage: 0 } } },
        { code: "exprunes4", trigger: { unit: { code: "exprunes4", stage: 0 } } }
    ].forEach((entry) => {
        dynamic[entry.code] = {
            priority: 1,
            trigger: entry.trigger,
            dynamic: {
                rowCtor: StagesQuestRow,
                getTitle: function () {
                    return Messages.get(`Quest.${entry.code}.title`);
                },
                getGoal: function (quest) {
                    return (1 << quest.goal) - 1;
                },
                getIcon: function () {
                    return UnitView.getUnitImage({ code: entry.code, stage: 0 }, { alignAnchorX: true });
                },
                addProgress: function (quest, options) {
                    const unit = options.unit || options.affected;
                    quest.progress |= (1 << unit.stage);
                }
            },
            quest: { type: Map2d.MINE, unit: { code: entry.code } }
        };
    });

    QuestsConfig[`${locationId}_dynamic`] = dynamic;
};
